import React from 'react'
import { TextField, InputAdornment, IconButton } from '@mui/material'
import { CalendarToday } from '@mui/icons-material'
import { PayPeriodData } from '../../../models/enhancement/pay-period-data'
import { formatPayPeriodDisplay } from '../../../utils/payPeriodFormatting'

interface PayPeriodFieldProps {
  label: string;
  value?: PayPeriodData | null;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  dataTestId?: string;
  error?: boolean;
  helperText?: string;
}

function PayPeriodField({
  label,
  value,
  onClick,
  disabled = false,
  dataTestId,
  error = false,
  helperText
}: PayPeriodFieldProps) {
  
  const displayValue = value ? formatPayPeriodDisplay(value) : ''
  
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      onClick(event)
    }
  }

  const handleIconClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation() // Prevent bubbling to TextField
    if (!disabled) {
      onClick(event)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    e.preventDefault()
  }

  return (
    <TextField
      fullWidth
      label={label}
      value={displayValue}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      error={error}
      helperText={helperText}
      autoComplete="off"
      InputProps={{
        readOnly: true,
        style: { cursor: disabled ? 'default' : 'pointer' },
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleIconClick}
              disabled={disabled}
              edge="end"
              size="small"
              style={{ cursor: disabled ? 'default' : 'pointer' }}
            >
              <CalendarToday fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      data-testid={dataTestId}
      sx={{
        '& .MuiInputBase-input': {
          cursor: disabled ? 'default' : 'pointer',
        },
      }}
    />
  )
}

export default PayPeriodField